export default __webpack_public_path__ + "51c8ba62e582ab9b50746796377845ce.png";